// sudo uv4l --driver dummy  --device-name=uv4l  --server-option '--use-ssl=no' --server-option '--ssl-private-key-file=/home/pi/certs/privkey.pem' --server-option '--ssl-certificate-file=/home/pi/certs/fullchain.pem' --server-option '--port=80' --server-option '--www-root-path=/usr/share/uv4l/demos/facedetection/' --server-option '--www-index-file=index.html' --server-option '--www-webrtc-signaling-path=/webrtc' --server-option=--enable-webrtc-audio=yes --server-option=--enable-webrtc-video=no --server-option=--webrtc-echo-cancellation=yes -v 6
const uv4lClient = (intercom_id, remote_video_element_id, state_update_callback) => {
    // var signalling_server_address = server_hostname;
    let isFirefox = typeof InstallTrigger !== 'undefined';// Firefox 1.0+

    let ws = null;
    let pc;
    let gn;
    let datachannel, localdatachannel;
    var audio_video_stream;
    let pcConfig = {/*sdpSemantics : "plan-b"*,*/ "iceServers": [
            {"urls": "stun:stun.kask.io"}, 
            {"urls": "turn:turn.kask.io", "username": "coturner", "credential":".CoTurner."}, 

        ]};
    let pcOptions = {
        optional: [
            // Deprecated:
            //{RtpDataChannels: false},
            //{DtlsSrtpKeyAgreement: true}
        ]
    };
    let mediaConstraints = {
        optional: [],
        mandatory: {
            OfferToReceiveAudio: true,
            OfferToReceiveVideo: true
        }
    };
    let keys = [];
    let trickle_ice = true;
    let remoteDesc = false;
    let iceCandidates = [];

    RTCPeerConnection = window.RTCPeerConnection || /*window.mozRTCPeerConnection ||*/ window.webkitRTCPeerConnection;
    RTCSessionDescription = /*window.mozRTCSessionDescription ||*/ window.RTCSessionDescription;
    RTCIceCandidate = /*window.mozRTCIceCandidate ||*/ window.RTCIceCandidate;
    navigator.getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia || navigator.msGetUserMedia;
    let URL = window.URL || window.webkitURL;

    function createPeerConnection() {
        try {
            let pcConfig_ = pcConfig;
            try {
                // ice_servers = document.getElementById('ice_servers').value;
                let ice_servers = undefined;
                if (ice_servers) {
                    pcConfig_.iceServers = JSON.parse(ice_servers);
                }
            } catch (e) {

                console.error(e + "\nExample: "
                        + '\n[ {"urls": "stun:stun1.example.net"}, {"urls": "turn:turn.example.org", "username": "user", "credential": "myPassword"} ]'
                        + "\nContinuing with built-in RTCIceServer array");
            }
            // console.log(JSON.stringify(pcConfig_));
            pc = new RTCPeerConnection(pcConfig_, pcOptions);
            pc.onicecandidate = onIceCandidate;
            if ('ontrack' in pc) {
                pc.ontrack = onTrack;
            } else {
                pc.onaddstream = onRemoteStreamAdded; // deprecated
            }
            pc.onremovestream = onRemoteStreamRemoved;
            pc.ondatachannel = onDataChannel;
            console.log("peer connection successfully created!");
        } catch (e) {
            console.error("createPeerConnection() failed");
        }
    }

    function onDataChannel(event) {
        console.log("onDataChannel()");
        datachannel = event.channel;

        event.channel.onopen = function () {
            console.log("Data Channel is open!");
            // document.getElementById('datachannels').disabled = false;
        };

        event.channel.onerror = function (error) {
            console.error("Data Channel Error:", error);
        };

        event.channel.onmessage = function (event) {
            console.log("Got Data Channel Message:", event.data);
            // document.getElementById('datareceived').value = event.data;
        };

        event.channel.onclose = function () {
            datachannel = null;
            // document.getElementById('datachannels').disabled = true;
            console.log("The Data Channel is Closed");
        };
    }

    function onIceCandidate(event) {
        if (event.candidate) {
            let candidate = {
                sdpMLineIndex: event.candidate.sdpMLineIndex,
                sdpMid: event.candidate.sdpMid,
                candidate: event.candidate.candidate
            };
            let request = {
                what: "addIceCandidate",
                data: JSON.stringify(candidate)
            };
            ws.send(JSON.stringify(request));
        } else {
            console.log("End of candidates.");
        }
    }

    function addIceCandidates() {
        iceCandidates.forEach(function (candidate) {
            pc.addIceCandidate(candidate,
                function () {
                    // console.log("IceCandidate added: " + JSON.stringify(candidate));
                },
                function (error) {
                    console.error("addIceCandidate error: " + error);
                }
            );
        });
        iceCandidates = [];
    }

    function onRemoteStreamAdded(event) {
        console.log("Remote stream added:", event.stream);
        let remoteVideoElement = document.getElementById(remote_video_element_id);
        remoteVideoElement.srcObject = event.stream;
        //remoteVideoElement.play();
    }

    function onTrack(event) {
        console.log("Remote track!");
        let remoteVideoElement = document.getElementById(remote_video_element_id);
        remoteVideoElement.srcObject = event.streams[0];
        //remoteVideoElement.play();
        state_update_callback({state: "FIN-ON_TRACK"});
    }

    function onRemoteStreamRemoved(event) {
        let remoteVideoElement = document.getElementById(remote_video_element_id);
        remoteVideoElement.srcObject = null;
        remoteVideoElement.src = ''; // TODO: remove
        state_update_callback({state: "FIN-OFF_STREAM_REMOVED"});
    }

    function start() {
        state_update_callback({state: "STARTING"});
        if ("WebSocket" in window) {
            // document.getElementById(stop_element_id).disabled = false;
            // document.getElementById(start_element_id).disabled = true;
            // document.documentElement.style.cursor = 'wait';
            // var server = document.getElementById("signalling_server").value.toLowerCase();

            var protocol = "wss";
            if (location.protocol == "http:"){
                protocol = "ws";
            }
            ws = new WebSocket(`${protocol}://${location.host}/intercom/${intercom_id}/_b__${window._bear}/stream/webrtc`);

            function call(stream) {
                iceCandidates = [];
                remoteDesc = false;
                createPeerConnection();
                if (stream) {
                    console.log("adding stream", stream);
                    pc.addStream(stream);
                }
                let request = {
                    what: "call",
                    options: {
                        force_hw_vcodec: false,
                        vformat: 105,
                        trickle_ice: true
                    }
                };
                ws.send(JSON.stringify(request));
                console.log("call(), request=" + JSON.stringify(request));
            }

            ws.onopen = function () {
                console.log("onopen()");

                audio_video_stream = null;
                let cast_mic = true;
                let cast_tab = false;
                let cast_camera = false;
                let cast_screen = false;
                let cast_window = false;
                let cast_application = false;
                let echo_cancellation = true;
                let localConstraints = {};
                if (cast_mic) {
                    if (echo_cancellation)
                        localConstraints['audio'] = isFirefox ? {echoCancellation: true} : {optional: [{echoCancellation: true}]};
                    else
                        localConstraints['audio'] = isFirefox ? {echoCancellation: false} : {optional: [{echoCancellation: false}]};
                } else if (cast_tab) {
                    localConstraints['audio'] = {mediaSource: "audioCapture"};
                } else {
                    localConstraints['audio'] = false;
                }
                if (cast_camera) {
                    localConstraints['video'] = true;
                } else if (cast_screen) {
                    if (isFirefox) {
                        localConstraints['video'] = {frameRate: {ideal: 30, max: 30},
                            //width: {min: 640, max: 960},
                            //height: {min: 480, max: 720},
                            mozMediaSource: "screen",
                            mediaSource: "screen"};
                    } else {
                        // chrome://flags#enable-usermedia-screen-capturing
                        // document.getElementById("cast_mic").checked = false;
                        localConstraints['audio'] = false; // mandatory for chrome
                        localConstraints['video'] = {'mandatory': {'chromeMediaSource':'screen'}};
                    }
                } else if (cast_window)
                    localConstraints['video'] = {frameRate: {ideal: 30, max: 30},
                        //width: {min: 640, max: 960},
                        //height: {min: 480, max: 720},
                        mozMediaSource: "window",
                        mediaSource: "window"};
                else if (cast_application)
                    localConstraints['video'] = {frameRate: {ideal: 30, max: 30},
                        //width: {min: 640, max: 960},
                        //height:  {min: 480, max: 720},
                        mozMediaSource: "application",
                        mediaSource: "application"};
                else
                    localConstraints['video'] = false;

                
                // var localVideoElement = document.getElementById(local_video_element_id);
                console.log("localConstraints", localConstraints);
                if (localConstraints.audio ) {
                    if (navigator.getUserMedia) {
                        navigator.getUserMedia(localConstraints, function (stream) {
                            audio_video_stream = stream;
                            call(stream);
                            // localVideoElement.muted = true;
                            // localVideoElement.srcObject = stream;
                            // localVideoElement.play();
                        }, function (error) {
                            stop();
                            // alert("An error has occurred. Check media device, permissions on media and origin.");
                            console.error(error);
                        });
                    } else {
                        console.log("getUserMedia not supported");
                    }
                } else {
                    call();
                }
            };

            ws.onmessage = function (evt) {
                let msg = JSON.parse(evt.data);
                let what, data;
                

                if (msg.what !== 'undefined') {
                    what = msg.what;
                    data = msg.data;
                }
                //console.log("message=" + msg);
                console.log("ws message", msg);

                switch (what) {
                    case "offer":
                        pc.setRemoteDescription(new RTCSessionDescription(JSON.parse(data)),
                                function onRemoteSdpSuccess() {
                                    remoteDesc = true;
                                    addIceCandidates();
                                    console.log('onRemoteSdpSucces()');
                                    pc.createAnswer(function (sessionDescription) {
                                        pc.setLocalDescription(sessionDescription);
                                        let request = {
                                            what: "answer",
                                            data: JSON.stringify(sessionDescription)
                                        };
                                        ws.send(JSON.stringify(request));
                                        // console.log(request);

                                    }, function (error) {
                                        console.error("Failed to createAnswer: " + error);

                                    }, mediaConstraints);
                                },
                                function onRemoteSdpError(event) {
                                    console.error('Failed to set remote description (unsupported codec on this browser?): ' + event);
                                    stop();
                                }
                        );

                        /*
                            * No longer needed, it's implicit in "call"
                        var request = {
                            what: "generateIceCandidates"
                        };
                        console.log(request);
                        ws.send(JSON.stringify(request));
                        */
                        break;

                    case "answer":
                        break;

                    case "message":
                        console.error(msg.data);
                        // state_update_callback({error: msg.data})
                        state_update_callback({state: "FIN-OFF_BUSY", error: msg.data});
                        break;

                    case "iceCandidate": // when trickle is enabled
                        if (!msg.data) {
                            console.log("Ice Gathering Complete");
                            break;
                        }
                        let elt = JSON.parse(msg.data);
                        let candidate = new RTCIceCandidate({sdpMLineIndex: elt.sdpMLineIndex, candidate: elt.candidate});
                        iceCandidates.push(candidate);
                        if (remoteDesc)
                            addIceCandidates();
                        // document.documentElement.style.cursor = 'default';
                        break;

                    case "iceCandidates": // when trickle ice is not enabled
                        let candidates = JSON.parse(msg.data);
                        for (let i = 0; candidates && i < candidates.length; i++) {
                            let elt = candidates[i];
                            let candidate = new RTCIceCandidate({sdpMLineIndex: elt.sdpMLineIndex, candidate: elt.candidate});
                            iceCandidates.push(candidate);
                        }
                        if (remoteDesc)
                            addIceCandidates();
                        // document.documentElement.style.cursor = 'default';
                        break;
                }
            };

            ws.onclose = function (evt) {
                if (pc) {
                    pc.close();
                    pc = null;
                }
                // document.getElementById(stop_element_id).disabled = true;
                // document.getElementById(start_element_id).disabled = false;
                // document.documentElement.style.cursor = 'default';
            };

            ws.onerror = function (evt) {
                console.error("An error has occurred!", evt);
                ws.close();
            };

        } else {
            console.error("Sorry, this browser does not support WebSockets.");
        }
    }

    function stop() {
        state_update_callback({state: "STOPPING"});
        if (datachannel) {
            console.log("closing data channels");
            datachannel.close();
            datachannel = null;
            // document.getElementById('datachannels').disabled = true;
        }
        if (localdatachannel) {
            console.log("closing local data channels");
            localdatachannel.close();
            localdatachannel = null;
        }
        if (audio_video_stream) {
            try {
                if (audio_video_stream.getVideoTracks().length)
                    audio_video_stream.getVideoTracks()[0].stop();
                if (audio_video_stream.getAudioTracks().length)
                    audio_video_stream.getAudioTracks()[0].stop();
                audio_video_stream.stop(); // deprecated
            } catch (e) {
                for (var i = 0; i < audio_video_stream.getTracks().length; i++)
                    audio_video_stream.getTracks()[i].stop();
            }
            audio_video_stream = null;
        }
        document.getElementById(remote_video_element_id).srcObject = null;
        // document.getElementById(local_video_element_id).srcObject = null;
        document.getElementById(remote_video_element_id).src = ''; // TODO; remove
        // document.getElementById(local_video_element_id).src = ''; // TODO: remove
        if (pc) {
            pc.close();
            pc = null;
        }
        if (ws) {
            ws.close();
            ws = null;
        }
        // document.getElementById(stop_element_id).disabled = true;
        // document.getElementById(start_element_id).disabled = false;
        // document.documentElement.style.cursor = 'default';
        state_update_callback({state: "FIN-OFF_STOP_DONE"})
    }

    function mute_mic() {
        audio_video_stream.getAudioTracks()[0].enabled = false;
        // audio_video_stream.getAudioTracks()[0].stop();
        // let remoteVideo = document.getElementById(remote_video_element_id);
        // remoteVideo.muted = true;
        state_update_callback({state: "FIN-ON_TRACK_MICMUTED"});
        
    }
    function unmute_mic() {
        audio_video_stream.getAudioTracks()[0].enabled = true;
        // let remoteVideo = document.getElementById(remote_video_element_id);
        // remoteVideo.muted = false;
        state_update_callback({state: "FIN-ON_TRACK"});
    }



    return {
        start, stop, mute_mic, unmute_mic
    }


    // window.onbeforeunload = function () {
    //     if (ws) {
    //         ws.onclose = function () {}; // disable onclose handler first
    //         stop();
    //     }
    // };
}

export default uv4lClient;